import { Box, Flex, Icon, Link, LinkProps, Text } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import { getStyles } from './styles';

export interface SiderBarLinkProps extends LinkProps {
  to: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  activeIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  label: string;
  subLabel?: string;
  isCompact?: boolean;
}

const SiderBarLinkComponent = (
  {
    to,
    icon,
    activeIcon,
    label,
    subLabel,
    sx,
    isCompact,
    ...rest
  }: SiderBarLinkProps,
  ref
) => {
  const {
    linkSx,
    wrapperSx,
    iconSx,
    primaryLabelSx,
    secondaryLabelSx,
  } = getStyles(!!activeIcon, isCompact, sx);

  const title = subLabel
    ? `${label}
${subLabel}`
    : label;
  return (
    <Box ref={ref} {...rest}>
      <Link as={NavLink} to={to} sx={linkSx} draggable="false">
        <Flex gap={2} sx={wrapperSx} title={title}>
          <Icon sx={iconSx} as={icon} />
          <Icon sx={iconSx} className="active" as={activeIcon} />
          {!isCompact && (
            <Box overflow="hidden">
              <Text sx={primaryLabelSx}>{label}</Text>
              {subLabel && <Text sx={secondaryLabelSx}>{subLabel}</Text>}
            </Box>
          )}
        </Flex>
      </Link>
    </Box>
  );
};

export const SiderBarLink = forwardRef(SiderBarLinkComponent);
